import * as React from "react";
const SvgCheckboxOff = props => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><rect x={4.5} y={4.5} width={15} height={15} rx={1.5} fill="none" /></svg>;
export { SvgCheckboxOff as ReactComponent };